import urlConstants from '~/lib/constants/url.constants';
import { CacheTag } from '~/store/services/CacheTag';
import { ENUMERATION_CACHE_TIME } from '~/store/services/enumerations';

import api from '../api';

export type GetNoteTemplateRevisionsRequest = {
  providerTypes?: string;
  latestRevisionOnly?: boolean;
  version?: number;
};

export const noteTemplateRevisionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNoteTemplateRevisions: build.query<
      NoteTemplateRevision[],
      GetNoteTemplateRevisionsRequest
    >({
      query: ({ providerTypes, latestRevisionOnly, version }) => ({
        url: urlConstants.clinical_data.listTemplateRevision,
        method: 'GET',
        params: {
          'latest-revision-only': latestRevisionOnly,
          'provider-type': providerTypes,
          version,
        },
      }),
      keepUnusedDataFor: ENUMERATION_CACHE_TIME,
    }),
    getNoteTemplateRevisionById: build.query<NoteTemplateRevision, string>({
      query: (templateRevisionId: string) => ({
        url: urlConstants.clinical_data.getTemplateRevisionById(
          templateRevisionId,
        ),
        method: 'GET',
      }),
      keepUnusedDataFor: ENUMERATION_CACHE_TIME,
    }),
    addNoteTemplateRevision: build.mutation<
      { templateId: string; templateRevisionId: string },
      {
        templateId: string;
        templateJson: JSON;
        surveyJsId: string;
      }
    >({
      query: ({ templateId, templateJson, surveyJsId }) => ({
        method: 'POST',
        url: urlConstants.clinical_data.addNoteTemplateRevision(templateId),
        body: { templateJson, surveyJsId },
      }),
      invalidatesTags: [{ type: CacheTag.NoteTemplateRevisions }],
    }),
  }),
});

export const {
  useGetNoteTemplateRevisionsQuery,
  useAddNoteTemplateRevisionMutation,
  useGetNoteTemplateRevisionByIdQuery,
} = noteTemplateRevisionsApi;
